export default function Reconciliation() {
  return (
    <>
      <div className="screen active" id="screen-recon">
        <div className="page-head">
          <div>
            <h1>Reconciliation</h1>
            <div className="ph-sub">
              Match portal transactions against biller &amp; settlement
              references
            </div>
          </div>
        </div>
        <div className="chip-row" style={{ marginBottom: 16 }}>
          <div className="fchip active" onclick="filterRecon('all',this)">
            All
          </div>
          <div className="fchip" onclick="filterRecon('matched',this)">
            Matched
          </div>
          <div className="fchip" onclick="filterRecon('unmatched',this)">
            Unmatched
          </div>
          <div className="fchip" onclick="filterRecon('exception',this)">
            Exceptions
          </div>
        </div>
        <div className="card">
          <div className="table-wrap">
            <table className="data-table" id="recon-table">
              <tbody>
                <tr>
                  <th>Payment ref</th>
                  <th>Biller ref</th>
                  <th>Settlement ref</th>
                  <th>Status</th>
                  <th className="tright">Action</th>
                </tr>
                <tr>
                  <td className="mono">CB-TX-99213</td>
                  <td className="mono">MSEDCL-88213</td>
                  <td className="mono">STL-77213</td>
                  <td>
                    <span className="pill pill-success">Matched</span>
                  </td>
                  <td className="tright">
                    <span style={{ color: "var(--text-faint)", fontSize: 11 }}>
                      —
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="mono">CB-TX-99187</td>
                  <td className="mono">FASTAG-22187</td>
                  <td className="mono">STL-77187</td>
                  <td>
                    <span className="pill pill-success">Matched</span>
                  </td>
                  <td className="tright">
                    <span style={{ color: "var(--text-faint)", fontSize: 11 }}>
                      —
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="mono">CB-TX-99154</td>
                  <td className="mono">—</td>
                  <td className="mono">—</td>
                  <td>
                    <span className="pill pill-failed">Exception</span>
                  </td>
                  <td className="tright">
                    <button
                      className="btn btn-teal btn-sm"
                      onclick="resolveRecon('CB-TX-99154')"
                    >
                      Mark resolved
                    </button>
                  </td>
                </tr>
                <tr>
                  <td className="mono">CB-TX-98977</td>
                  <td className="mono">MTNL-99001</td>
                  <td className="mono">pending</td>
                  <td>
                    <span className="pill pill-pending">Unmatched</span>
                  </td>
                  <td className="tright">
                    <button
                      className="btn btn-teal btn-sm"
                      onclick="resolveRecon('CB-TX-98977')"
                    >
                      Mark resolved
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
